'use strict';

exports.__esModule = true;

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _draftJsAndroidFix = require('draft-js-android-fix');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var PrismaDecorator = (_temp2 = _class = function (_Component) {
  _inherits(PrismaDecorator, _Component);

  function PrismaDecorator() {
    var _temp, _this, _ret;

    _classCallCheck(this, PrismaDecorator);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      editing: false,
      showEditor: false
    }, _this.startEdit = function (event) {
      // event.preventDefault();
      // event.stopPropagation();
      var editing = _this.state.editing;
      var onEditStart = _this.props.onEditStart;

      if (!editing) {
        _this.setState({
          editing: true
        });

        onEditStart();
      }

      return;
    }, _this.endEdit = function (event) {
      // event.preventDefault();
      // event.stopPropagation();
      var editing = _this.state.editing;
      var onEditEnd = _this.props.onEditEnd;

      if (editing) {
        _this.setState({
          editing: false
        });

        onEditEnd();
      }

      return;
    }, _this.showEditor = function (event) {
      // event.preventDefault();
      // event.stopPropagation();
      _this.setState({
        showEditor: true
      });
    }, _this.hideEditor = function () {
      _this.setState({
        showEditor: false
      });
    }, _this.updateData = function (data) {
      var _this$props = _this.props,
          entityKey = _this$props.entityKey,
          contentState = _this$props.contentState,
          getEditorState = _this$props.getEditorState,
          onChange = _this$props.onChange;
      var blocksArray = contentState.getBlocksAsArray();

      var newContentState = _draftJsAndroidFix.ContentState.createFromBlockArray(blocksArray);

      newContentState = newContentState.mergeEntityData(entityKey, data);
      var editorState = getEditorState();

      var newEditorState = _draftJsAndroidFix.EditorState.push(editorState, newContentState, 'change-block-data');

      onChange(newEditorState);

      _this.forceUpdate();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  } // componentWillReceiveProps(nextProps, nextState) {
  // }


  PrismaDecorator.prototype.getCurrentEntity = function getCurrentEntity() {
    var _props = this.props,
        entityKey = _props.entityKey,
        contentState = _props.contentState;
    return contentState.getEntity(entityKey);
  };

  PrismaDecorator.prototype.getEntityRange = function getEntityRange(editorState, entityKey) {
    var block = this.getSelectedBlock(editorState);
    var entityRange = void 0;
    block.findEntityRanges(function (value) {
      return value.get('entity') === entityKey;
    }, function (start, end) {
      entityRange = {
        start: start,
        end: end,
        text: block.get('text').slice(start, end)
      };
    });
    return entityRange;
  };

  PrismaDecorator.prototype.getSelectedBlock = function getSelectedBlock(editorState) {
    if (editorState) {
      return this.getSelectedBlocksList(editorState).get(0);
    }

    return undefined;
  };

  PrismaDecorator.prototype.getSelectedBlocksList = function getSelectedBlocksList(editorState) {
    return this.getSelectedBlocksMap(editorState).toList();
  };
  /**
   * Function returns the first selected block.
   */


  PrismaDecorator.prototype.getSelectedBlock = function getSelectedBlock(editorState) {
    if (editorState) {
      return this.getSelectedBlocksList(editorState).get(0);
    }

    return undefined;
  };

  PrismaDecorator.prototype.getSelectedBlocksMap = function getSelectedBlocksMap(editorState) {
    var selectionState = editorState.getSelection();
    var contentState = editorState.getCurrentContent();
    var startKey = selectionState.getStartKey();
    var endKey = selectionState.getEndKey();
    var blockMap = contentState.getBlockMap();
    return blockMap.toSeq().skipUntil(function (_, k) {
      return k === startKey;
    }).takeUntil(function (_, k) {
      return k === endKey;
    }).concat([[endKey, blockMap.get(endKey)]]);
  }; // render() {
  //   return (
  //     <div>
  //     </div>
  //   );
  // }


  return PrismaDecorator;
}(_react.Component), _class.contextTypes = {}, _temp2);
PrismaDecorator.propTypes = process.env.NODE_ENV !== "production" ? {
  entityKey: _propTypes2.default.string.isRequired,
  children: _propTypes2.default.array,
  contentState: _propTypes2.default.object,
  onEditStart: _propTypes2.default.func.isRequired,
  onEditEnd: _propTypes2.default.func.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  getEditorState: _propTypes2.default.func.isRequired,
  isReadOnly: _propTypes2.default.func.isRequired
} : {};
exports.default = PrismaDecorator;
module.exports = exports['default'];